export const DATA_MANAGER_GA_FF = 'airtrack_provisioning_for_ga';
